function Alert( el ) {
	var t = this;
	t.el = el;
	t.body = document.body;
	t.header = document.querySelector('.header-bar');
	t.main = document.getElementsByTagName('main')[0];
	t.closeButton = t.el.querySelector('.js-close');
	t.activeClass = 'has-alert';
	t.init();
}

Alert.prototype.init = function() {
	var t = this;
	t.open();
	t.updateOffset();
	window.addEventListener('resize', t.updateOffset.bind(t));
	t.closeButton.addEventListener('click', t.close.bind(t));
};

Alert.prototype.open = function() {
	var t = this;
	t.body.classList.add( t.activeClass );
};

Alert.prototype.close = function() {
	var t = this;
	t.body.classList.remove( t.activeClass );
	t.main.style.paddingTop = '';
};

Alert.prototype.updateOffset = function() {
	var t = this,
			offset = t.header.clientHeight;
	t.main.style.paddingTop = offset + 'px';
};

module.exports = Alert;
